import React, { useState, useEffect } from 'react';

import './styles.css';

import coachServices from '../../../../services/academy/coachServices';

import CoachClassCardItem from './CoachClassCardItem';
import PopupClassLink from './PopupClassLink';
import { FaUsers } from 'react-icons/fa';
import ActivityIndicator from '../../../../components/ActivityIndicator';

export default function CoachClassCard(props) {
    const [popupClassLinkVisible, setPopupClassLinkVisible] = useState(false);
    const [coachInfos, setCoachInfos] = useState(null);

    useEffect(() => {
        if (props.coachInfos)
            setCoachInfos(props.coachInfos);
    }, [props.coachInfos]);

    async function unlinkCoachClass(classId, className) {
        if (props.coachInfos && props.coachInfos.id) {
            // eslint-disable-next-line no-restricted-globals
            if (confirm(`Deseja desvincular o professor da turma ${className}?`)) {
                const response = await coachServices.deleteUnlinkCoachClass(props.coachInfos.id, classId);
                if (response.status === 200) {
                    if (props.onUpdate) props.onUpdate();
                } else
                    alert("Erro ao desvincular professor de uma turma, tente novamente!");
            }
        } else
            alert("Erro ao identificar professor, tente novamente!");
    }

    return (
        <div className='coach-page-card' id='card-class'>
            <div className='coach-card-class-header'>
                <h4><b><FaUsers />Turmas</b></h4>
                {
                    props.coachInfos && props.coachInfos.id ?
                        <>
                            <button
                                onClick={() => { setPopupClassLinkVisible(true) }}
                            >
                                Vincular turma
                            </button>
                            <PopupClassLink
                                visibility={popupClassLinkVisible}
                                setVisibility={setPopupClassLinkVisible}
                                coachId={coachInfos ? coachInfos.id : null}
                                coachClasses={props.coachInfos.turmas}
                                onLink={props.onUpdate}
                            />
                        </>
                        : []
                }
            </div>
            {
                props.coachInfos.turmas ?
                    props.coachInfos.turmas.length ?
                        <ul className='coach-card-class-list'>
                            {
                                props.coachInfos.turmas.map((item, index) =>
                                    <CoachClassCardItem
                                        key={item.id}
                                        id={item.id}
                                        name={item.nome}
                                        ageGroup={item.faixa_etaria}
                                        students={item.numero_alunos}
                                        unlink={() => unlinkCoachClass(item.id, item.nome)}
                                    />
                                )
                            }
                        </ul>
                        : []
                    : <ActivityIndicator />
            }
        </div>
    )
}